import { motion } from "framer-motion";
import { fadeUp, fadeUpChild, stagger, viewportOnce } from "./anim";
import { skillGroups } from "@/data/resume";

export const Skills = () => {
  return (
    <section
      id="skills"
      data-testid="skills"
      className="relative border-y border-black/10 bg-[#F1EFE8]"
    >
      <div className="mx-auto max-w-[1500px] px-6 py-24 md:px-12 md:py-36">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mb-16"
        >
          <span className="font-mono-x text-xs uppercase tracking-[0.3em] text-[#9A7526]">
            (05) — Capabilities
          </span>
          <h2 className="mt-6 font-display text-4xl font-light tracking-tight text-[#1A1A18] md:text-6xl">
            What I bring to the table.
          </h2>
        </motion.div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-8"
        >
          {skillGroups.map((g) => (
            <motion.div
              key={g.label}
              variants={fadeUpChild}
              data-testid={`skill-group-${g.label}`}
              className="border-t border-black/10 pt-6"
            >
              <h3 className="font-mono-x text-xs uppercase tracking-[0.25em] text-[#6E6D66]">
                {g.label}
              </h3>
              <ul className="mt-6 space-y-4">
                {g.items.map((s) => (
                  <li
                    key={s}
                    className="font-display text-2xl font-light text-[#1A1A18] transition-colors duration-300 hover:text-[#9A7526] md:text-3xl"
                  >
                    {s}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
